export const EventNames = {
  QUIZ_PAGE_LOADED: "quiz_page_loaded",
  QUIZ_INTERMEDIATE_PAGE_LOAD: "quiz_intermediate_page_load",
  QUESTION_VIEWED: "question_viewed",
  NEXT_BUTTON_CLICKED: "next_button_clicked",
  USER_DETAILS_PAGE_LOADED: "user_details_page_loaded",
  USER_INFO_SUBMITTED: "user_info_submitted",
  QUIZ_RESULT_PAGE_LOADED: "quiz_result_page_loaded",
  QUIZ_RESULT_PAGE_SCROLLED: "quiz_result_page_scrolled",
  TRACK_HORMONES_CLICKED: "track_hormones_clicked",
  BUY_NOW_CLICKED: "buy_now_clicked",
  FAQ_DROP_DOWN_CLICKED: "faq_drop_down_clicked",
  ORDER_NOW_CLICKED: "order_now_clicked",
  GET_INITO_KIT_CLICKED: "get_inito_kit_clicked",
  CLOSE_BUTTON_ORDER_POPUP_CLICKED: "close_button_order_popup_clicked",
  HOW_INITO_WORK_CLICKED: "how_inito_work_clicked",

  QUIZ_TOUCHPOINT_CLICKED: "quiz_touchpoint_clicked",
  QUIZ_TOUCHPOINT_VIEWED: "quiz_touchpoint_viewed",
  BOTTOM_SHEET_CLICKED: "bottom_sheet_clicked",
  BOTTOM_SHEET_DISPLAYED: "bottom_sheet_displayed",
  BOTTOM_SHEET_DISMISSED: "bottom_sheet_dismissed",
  QUIZ_RESULTS_REOPENED: "quiz_results_reopened",
  HOME_PAGE_SCROLLED: "home_page_scrolled",
  HOME_PAGE_LOADED: "home_page_loaded",
  PHONE_MODEL_SELECTED: "phone_model_selected",
  PHONE_CATEGORY_SELECTED: "phone_category_selected",
  CHECKOUT_NOW_CLICKED: "checkout_now_clicked",
  CHECKOUT_INTERMEDIATE_CLICKED: "checkout_now_clicked_intermediate",
  NG_SIDE_BANNER_VIEWED: "ng_side_banner_viewed",
  FLOW_CATEGORY_SELECTION: "flow_category_selection",
  FLOW_NEXT_CLICKED: "flow_next_button_clicked",
  FLOW_MODEL_SELECTION: "flow_model_selection",
  TRY_INITO_CLICKED: "try_inito_clicked",
  FOR_ANDROID_CLICKED: "for_android_clicked",
  FOR_IOS_CLICKED: "for_ios_clicked",
  WHATS_INCLUDED_EXPANDED: "whats_included_expanded",
  ANDROID_FAB_DISMISSED: "android_fab_dismissed",
  DISCOUNT_FAB_CLICKED: "discount_fab_clicked",
  DISCOUNT_POPUP_VIEWED: "discount_popup_viewed",
  ANDROID_DISCOUNT_POPUP_CLOSE_BUTTON_CLICKED:
    "android_discount_popup_close_button_clicked",
  ANDROID_ANNOUNCEMENT_POPUP_GET_INITO_CLICKED:
    "android_announcement_popup_get_inito_clicked",
  ANDROID_ANNOUNCEMENT_POPUP_KNOW_MORE_CLICKED:
    "android_announcement_popup_know_more_clicked",
  NOTIFY_MODAL_EMAIL_SUBMIT: "notify_modal_email_submit",
  NOTIFY_ME_CLICKED: "notify_me_clicked",
  NOTIFY_ME_MODAL_DISMISSED: "notify_me_modal_dismissed",
  NOTIFY_SUCCESSFUL_MODAL_DISMISSED: "notify_successful_modal_dismissed",
  NOTIFY_SUCCESSFUL_MODAL_CROSS_BUTTON_CLICKED:
    "notify_successful_modal_cross_button_clicked",
  PLAYSTORE_CLICKED: "playstore_clicked",
  APPSTORE_CLICKED: "appstore_clicked",
  ANNOUNCEMENT_POPUP_VIEWED: "announcement_popup_viewed",
  BUY_NOW_PAGE_LOADED: "buy-now_page_loaded",
  BUY_NOW_PAGE_SCROLLED: "buy-now_page_scrolled",
  FAQ_PAGE_SCROLLED: "faqs_page_scrolled",
  CONTACT_US_PAGE_SCROLLED: "contact-us_page_scrolled",
  ABOUT_US_PAGE_SCROLLED: "about-us_page_scrolled",
  MEDICAL_ADVISORS_PAGE_SCROLLED: "medical-advisors_page_scrolled",
  CAREERS_PAGE_SCROLLED: "careers_page_scrolled",
  DISCOUNT_POPUP_CLOSE_BUTTON_CLICKED: "discount_popup_close_button_clicked",
  DISCOUNT_POPUP_EMAIL_SUBMITTED: "discount_popup_email_submitted",
  OC_PAGE_LOADED: "OC_page_loaded",
  OC_DETAILS_SUBMITTED: "OC_details_submitted",
  OC_RESULTS_PAGE_LOADED: "OC_results_page_loaded",
  OC_RESULTS_ACCORDION_CLICKED: "OC_results_accordion_clicked",
  OC_FAQ_CLICKED: "OC_faq_clicked",
  OC_CALENDAR_INTERACTED: "OC_calendar_interacted",
  OC_CYCLE_COUNTER_INTERACTED: "OC_cycle_counter_interacted",
  OC_TRY_INITO_CLICKED: "try_inito_clicked",
  TERMS_PAGE_VIEWED: "terms_page_viewed",
  TERMS_PAGE_SCROLLED: "terms_page_scrolled",
  PRIVACY_POLICY_PAGE_VIEWED: "privacy_policy_page_viewed",
  PRIVACY_POLICY_PAGE_SCROLLED: "privacy_policy_page_scrolled",
  REPLACEMENTS_AND_WARRANTY_PAGE_VIEWED:
    "replacements_and_warranty_page_viewed",
  REPLACEMENTS_AND_WARRANTY_PAGE_SCROLLED:
    "replacements_and_warranty_page_scrolled",
  CONSUMER_HEALTH_DATA_PRIVACY_POLICY_PAGE_VIEWED:
    "consumer_health_data_privacy_policy_page_viewed",
  CONSUMER_HEALTH_DATA_PRIVACY_POLICY_PAGE_SCROLLED:
    "consumer_health_data_privacy_policy_page_scrolled",
  SECTION_VIEWED: "section_viewed",
  SECTION_SCROLLED: "section_scrolled",
  HORIZONTAL_SECTION_SCROLLED: "horizontal_section_scrolled",
  USE_CASE_CLICKED: "use_case_clicked",
  JOIN_COMMUNITY_CLICKED: "join_community_clicked",
  READ_BLOGS: "read_blogs",
  READ_MORE_CLICKED: "read_more_clicked",
  VIDEO_PLAYED: "video_played",
  VIDEO_PLAYED_CLICKED: "video_played_clicked",
  VIDEO_STOPPED_CLICKED: "video_stopped_clicked",
  PRODUCT_SELECTION_CLICKED: "product_selection_clicked",
  COMPARE_PRODUCTS_CLICKED: "compare_products_clicked",
  PRODUCT_TOGGLE_CLICKED: "product_toggle_clicked",
  HOW_TO_USE_VIEWED: "how_to_use_viewed",
  DRAWER_CLICKED: "drawer_clicked",
  SIDE_DRAWER_ITEM_CLICKED: "side_drawer_item_clicked",
  FOOTER_LINK_CLICKED: "footer_link_clicked",
  FAQ_QUESTION_OPENED: "faq_question_opened",
  USER_REVIEW_CLICKED: "user_review_clicked",
  COMPARISON_TAB_CLICKED: "comparison_tab_clicked",
  QUIZ_RESTART_CLICKED: "quiz_restart_click",
};

export const SectionTypes = {
  HEADER_STRIP: "header_strip",
  HERO_BANNER: "hero_banner",
  NOT_ALL_TESTS_ARE_EQUAL: "not_all_tests_are_equal",
  STATS_SECTION: "stats_section",
  CONFIRM_WITH_REAL_DATA: "confirm_with_real_data",
  WHY_MEASURE_PDG: "why_measure_pdg",
  SIX_RIGHT_DAYS: "six_right_days",
  TRACK_ACTUAL_HORMONE_DATA: "track_actual_hormone_data",
  USE_CASE: "use_case",
  PRODUCT_TECH: "product_tech",
  PRODUCT_TECH_STORIES: "product_tech_stories",
  SEE_HOW_IT_WORKS: "see_how_it_works",
  USER_REVIEW: "user_review",
  RECOMMENDED_BY_CLINICIANS: "recommended_by_clinicians",
  COMMUNITY_SECTION: "community_section",
  BLOG_SECTION: "blog_section",
  PDP_BANNER: "pdp_banner",
  PRODUCT_SELECTION: "product_selection",
  ALLY_IN_JOURNEY: "ally_in_journey",
  STRIPS_SECTION: "strips_section",
  HOW_TO_USE: "how_to_use",
  COMPARISION_INITO_VS_OVULATIONTEST: "comparision_inito_vs_ovulationtest",
  FOOTER: "footer",
  MEDICAL_ADVISORS: "medical_advisors",
  DRAWER: "drawer",
  FAQ: "faq",
  FAQ_VIEWED: "faq_viewed",
} as const;

export type SectionType = (typeof SectionTypes)[keyof typeof SectionTypes];
export type FlowType = "OG" | "IR";

export function getFlowType(workflow?: string): FlowType {
  if (workflow === "og") {
    return "OG";
  }
  return "IR";
}

export function withSectionType<T extends Record<string, unknown>>(
  sectionType: string,
  eventProperties?: T,
) {
  return {
    section_type: sectionType.toLowerCase(),
    ...(eventProperties ?? {}),
  };
}

export function withFlowType<T extends Record<string, unknown>>(
  workflow: string | undefined,
  eventProperties?: T,
) {
  return {
    flow_type: getFlowType(workflow),
    ...(eventProperties ?? {}),
  };
}

export function withSectionAndFlow<T extends Record<string, unknown>>(
  sectionType: string,
  workflow?: string,
  eventProperties?: T,
) {
  return withSectionType(sectionType, withFlowType(workflow, eventProperties));
}

export const sendEvent = (
  eventName: string,
  eventProperties: Record<string, unknown> = {},
) => {
  const ConsentEvent = (window as any)?.__inito__?.EventManager;
  if (!ConsentEvent) {
    console.log("ConsentEvent is not defined");
    return;
  }

  const enriched: Record<string, unknown> = { ...eventProperties };

  try {
    const raw = document.cookie
      .split("; ")
      .find((c) => c.startsWith("quiz_attribution="));
    if (raw) {
      const attrs = JSON.parse(decodeURIComponent(raw.split("=")[1]!));
      if (
        attrs.touchpoint_type &&
        !enriched.touchpoint_type &&
        eventName !== EventNames.HOME_PAGE_LOADED &&
        eventName !== EventNames.SECTION_VIEWED && 
        eventName !== EventNames.HOME_PAGE_SCROLLED
      )
        enriched.touchpoint_type = attrs.touchpoint_type;
    }
  } catch {
    /* attribution cookie absent or malformed */
  }

  const consentData = {
    name: eventName,
    eventProperties: enriched,
  };
  const consentEvent = new ConsentEvent(consentData);
  consentEvent.sendEvent();
};
